<template>
    <div >
        <Nav/>
         <div class="jumbotron jumbotron-fluid">
          <div class="container">
            <div class="row text-center jumbotext">
            <div class="col-12">
                    <h1 class="text-white ">AfCFTA RESOURCES</h1>
            </div>
            </div>
        </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12">
                <Resources/>
            </div>
        </div>
        <FinalFooter />
    </div>
</template>

<script>
import Nav from '@/components/appBar.vue'
import Resources from '@/components/Resource.vue'
import FinalFooter from '../components/FinalFooter'
    export default {
        components:{
            Nav ,
            Resources,
            FinalFooter
        }
    }
</script>

<style scoped>
.jumbotron{
    background-color:red;
    background:url('../assets/AFCFTA  HEADER ARTICLES.jpg');
    background-size:cover;
    height:300px;
    margin-top:-75px
    }
    .jumbotext{
        margin-top:120px
    }
   h1{
       padding-top:20px
   }
   @media screen and (max-width: 600px) {
       h1 {
           font-size: 1.8em;
           margin-top:50px;
       }
   }
</style>